import { MessageSquare } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ChatIcon = DeckardIconWrapper({ Icon: MessageSquare });
